// src/components/lessons/renderers/ExampleRenderer.jsx
import React, { useState } from 'react';
import { FileCheck } from 'lucide-react';

const ExampleRenderer = ({ block, isMobile }) => {
  const [isHovered, setIsHovered] = useState(false);
     const processText = (text) => {
    if (typeof text !== 'string') return text;
    const parts = text.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, index) => {
      return index % 2 === 1 ? (
        <strong key={index} style={{
          fontWeight: '700',
          color: '#000000',
          background: '#FFFFFF',
          padding: '0.125rem 0.375rem',
          borderRadius: '0.25rem',
          border: '1px solid #E5E7EB'
        }}>
          {part}
        </strong>
      ) : part;
    });
  };
  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <div
        style={{
          background: '#FFFFFF',
          borderRadius: '0.75rem',
          padding: isMobile ? '1.25rem' : '1.5rem',
          border: '2px solid #000000',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          boxShadow: isHovered ? '0 8px 24px rgba(0, 0, 0, 0.12)' : '0 2px 8px rgba(0, 0, 0, 0.08)',
          transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
          position: 'relative',
          overflow: 'hidden'
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Blue accent bar */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '4px',
          background: '#3A86FF'
        }} />

        {/* Title */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          marginBottom: '1.25rem',
          marginTop: '0.5rem'
        }}>
          <div style={{
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            background: '#000000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'transform 0.3s ease',
            transform: isHovered ? 'rotate(12deg) scale(1.1)' : 'rotate(0deg) scale(1)'
          }}>
            <FileCheck style={{ width: '16px', height: '16px', color: '#3A86FF' }} />
          </div>
          <h4 style={{
            fontWeight: '700',
            color: '#000000',
            fontSize: isMobile ? '1rem' : '1.125rem',
            margin: 0
          }}>
            {block.title}
          </h4>
        </div>

        <div style={{
          fontSize: isMobile ? '0.9rem' : '0.95rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem'
        }}>
          {/* Situation */}
          {block.content?.situation && (
            <p style={{ marginBottom: '0.5rem', color: '#000000', lineHeight: '1.6', opacity: 0.8 }}>
  <strong style={{ color: '#000000', fontWeight: '700' }}>Situation:</strong> {processText(block.content.situation)}
</p>
          )}

          {/* Text content */}
          {block.content?.text && (
            <div style={{
              background: '#FAFBFC',
              padding: isMobile ? '1rem' : '1.25rem',
              borderRadius: '0.5rem',
              border: '1px solid #E5E7EB',
              borderLeft: '3px solid #3A86FF'
            }}>
              <p style={{
  color: '#000000',
  lineHeight: '1.7',
  margin: 0,
  opacity: 0.9
}}>
  {processText(block.content.text)}
</p>
            </div>
          )}

          {/* Questions with multiple choice */}
          {block.content?.questions && Array.isArray(block.content.questions) && (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '1rem',
              marginTop: '0.75rem'
            }}>
              {block.content.questions.map((q, qIndex) => (
                <div
                  key={qIndex}
                  style={{
                    background: '#FAFBFC',
                    padding: isMobile ? '1rem' : '1.25rem',
                    borderRadius: '0.5rem',
                    border: '1px solid #E5E7EB'
                  }}
                >
                  {/* Question */}
                  <p style={{
                    fontWeight: '700',
                    color: '#000000',
                    marginBottom: '1rem',
                    fontSize: isMobile ? '0.95rem' : '1rem'
                  }}>
                  {processText(q.question)}
                  </p>

                  {/* Options */}
                  <ul style={{
                    marginTop: '0.5rem',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.75rem',
                    paddingLeft: 0,
                    listStyle: 'none'
                  }}>
                    {q.options && q.options.map((choice, cIndex) => {
                      const isCorrect = choice.startsWith(q.answer);
                      return (
                        <li
                          key={cIndex}
                          style={{
                            padding: '0.75rem 1rem',
                            borderRadius: '0.5rem',
                            background: isCorrect ? '#000000' : '#FFFFFF',
                            color: isCorrect ? '#FFFFFF' : '#000000',
                            fontWeight: isCorrect ? '700' : '400',
                            border: isCorrect ? '2px solid #000000' : '1px solid #E5E7EB',
                            fontSize: isMobile ? '0.85rem' : '0.9rem',
                            position: 'relative',
                            paddingLeft: isCorrect ? '2rem' : '1rem'
                          }}
                        >
                          {isCorrect && (
                            <div style={{
                              position: 'absolute',
                              left: '0.75rem',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              width: '6px',
                              height: '6px',
                              borderRadius: '50%',
                              background: '#3A86FF'
                            }} />
                          )}
                          {processText(choice)}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExampleRenderer;